import store from "@/store";
import { getMultiTemplateAuth } from '@template/utils';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export const routerGuard = async (to, from, next) => {
    try {
        const isLoggedIn = store.getters.isAuthenticated;
        if(to.query.auth && !isLoggedIn) {
            await getMultiTemplateAuth(to);
            cookies.set('AUTH_TOKEN', to.query.auth);
            return next({ name: 'Home' })
        };
        let isModalOpen = document.querySelector('.modal.show')
        if (isModalOpen && isModalOpen.id != 'autosearcheader' && isModalOpen.id != 'exampleModal') {
            next(false);
            return;
        }
        const underMaintenance = store.getters.underMaintenance;
        const isMaintenancePage = to.name === 'Maintenance';
        if (underMaintenance) {
            if (!isMaintenancePage) {
                next({ name: 'Maintenance' });
                return;
            }
        } else {
            if (isMaintenancePage) {
                next({ name: 'Home' });
                return;
            }
        }

        next();
    } catch (e) {
        console.log(e);
    };

};